import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedImapServer = mutatorAction('updateAdvancedImapServer', function (imapServer) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.imapServer = imapServer;
});
//# sourceMappingURL=updateAdvancedImapServer.js.map